import { render, staticRenderFns } from "./ModalConfiguracaoTarja.vue?vue&type=template&id=5150538c&scoped=true"
import script from "./ModalConfiguracaoTarja.vue?vue&type=script&lang=js"
export * from "./ModalConfiguracaoTarja.vue?vue&type=script&lang=js"
import style0 from "./ModalConfiguracaoTarja.vue?vue&type=style&index=0&id=5150538c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5150538c",
  null
  
)

export default component.exports